import { render, staticRenderFns } from "./status-devices.vue?vue&type=template&id=54ec03a2&scoped=true&"
import script from "./status-devices.vue?vue&type=script&lang=js&"
export * from "./status-devices.vue?vue&type=script&lang=js&"
import style0 from "./status-devices.vue?vue&type=style&index=0&id=54ec03a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec03a2",
  null
  
)

export default component.exports